<template>
	<DNotice
		color="info"
		:title="$t('policy.enable_admin_access_enabled_title')"
		:description="$t('policy.enable_admin_access_enabled_description')"
	/>
</template>
